export enum AtiraLinkPlanTheme {
  PLAN_0 = 'FREE',
  PLAN_1 = 'BASIC',
  PLAN_2 = 'PRO',
}
